import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=57ff1cfb&scoped=true&"
var script = {}
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=57ff1cfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff1cfb",
  null
  
)

export default component.exports